<div class="chat-visit" [ngClass]="'chat-visit--' + tone">
  <span class="chat-visit__icon"><chat-icon [name]="icon" [size]="16"></chat-icon></span>
  <div class="chat-visit__body">
    <div class="chat-visit__title">
      {{ strings.visitCardTitle }}
      <span class="chat-visit__pill">{{ statusText }}</span>
    </div>
    <div class="chat-visit__when">{{ when }}<s *ngIf="previousWhen" class="chat-visit__previous">{{ previousWhen }}</s></div>
    <div *ngIf="params.cancelReason" class="chat-visit__reason">{{ params.cancelReason }}</div>
    <!-- "Adicionar ao calendário" é para o cliente: o staff já a tem no calendário do CRM -->
    <div class="chat-visit__actions" *ngIf="(scheduled && !evaluable && !canManage) || (canManage && (scheduled || evaluable))">
      <button *ngIf="scheduled && !evaluable && !canManage" type="button" class="chat-visit__btn" (click)="ics.emit()">
        <chat-icon name="arrowdown" [size]="13"></chat-icon>{{ strings.visitAddToCalendar }}
      </button>
      <button *ngIf="canManage && (scheduled || evaluable)" type="button" class="chat-visit__btn" (click)="requestForm.emit()">
        <chat-icon name="file" [size]="13"></chat-icon>{{ strings.visitRequestForm }}
      </button>
      <button *ngIf="canManage && scheduled && !evaluable" type="button" class="chat-visit__btn" (click)="reschedule.emit()">
        <chat-icon name="calendar" [size]="13"></chat-icon>{{ strings.rescheduleVisit }}
      </button>
      <button *ngIf="canManage && scheduled && !evaluable" type="button" class="chat-visit__btn chat-visit__btn--danger" (click)="cancel.emit()">
        {{ strings.visitCancel }}
      </button>
    </div>
  </div>
</div>
